import React, { createContext, useContext, useReducer } from 'react';
import MultiStepFormReducer from './MultiStepFormReducer';
import { validateOrResetLocalStorageOnIntroPage } from '@actions/formulary';
import { sourceOriginLead } from '@config/constants';

export const MultiStepFormContext = createContext();

const initialState = {
  currentStep: 1,
  maxStep: 8,
  formDataContext: {
    consentPartners: "off",
    dateOfBirth: null,
    hasRequestedAdvice: 0,
    sourceOriginLead
  },
  trainingId: null,
  trainingName: '',
  trainingNameId: 0,
  trainingInfos: {},
  loading: true,
  error: {},
};

let localState = JSON.parse(localStorage.getItem('localState'));
//parser la valeur provenant du localState pour s'assurer que le format correspond à ce qu'on attend et le reset si necessaire.
localState = validateOrResetLocalStorageOnIntroPage(localState);

export const useMultiStepContext = () => {
  return useContext(MultiStepFormContext);
};

//Todo refactor to put dispatct in it's own provider and pass only state in the main provider
export const MultiStepFormContextProvider = (props) => {
  const [state, dispatch] = useReducer(
    MultiStepFormReducer,
    localState || initialState
  );


  // ACTIONS

  const prevStep = () => {
    dispatch({
      type: 'PREV_STEP',
    });
  };

  const nextStep = () => {
    dispatch({
      type: 'NEXT_STEP',
    });
  };

  const firstStep = () => {
    dispatch({
      type: 'FIRST_STEP',
    });
  };

  const setStep = (step) => {
    dispatch({
      type: 'SET_STEP',
      payload: step,
    });
  };

  const setConfig = (config) => {
    dispatch({
      type: 'SET_CONFIG',
      payload: {
        currentStep: config.currentStep,
        maxStep: config.maxStep,
        domainId: config.domainId,
        trainingId: config.trainingId,
        trainingName: config.trainingName,
        origin: config.origin,
        phrases: config.phrases,
        config: config.config,
        visibleSteps: config.visibleSteps,
      },
    });
  };

  const setTrainingId = (id) => {
    dispatch({
      type: 'SET_TRAININGID',
      payload: id,
    });
  };

  const setTrainingName = (name) => {
    dispatch({
      type: 'SET_TRAININGNAME',
      payload: name,
    });
  };

  const setTrainingInfos = (trainingObj) => {
    dispatch({
      type: 'SET_TRAININGINFOS',
      payload: trainingObj,
    });
  }

  const setOrigin = (pathName) => {
    dispatch({
      type: 'SET_ORIGIN',
      payload: pathName,
    });
  };

  const setPhrases = (phrases) => {
    dispatch({
      type: 'SET_PHRASES',
      payload: phrases,
    });
  };

  const setCookiesUTM = (cookiesUTM) => {
    dispatch({
      type: 'SET_COOKIES_UTM',
      payload: cookiesUTM,
    });
  };

  const updateFormData = (newFormData) => {
    dispatch({
      type: 'UPDATE_FORMDATA',
      payload: newFormData,
    });
  };

  const resetFormData = () => {
    dispatch({
      type: 'RESET_FORMDATA',
      payload: initialState,
    });
  };

  const setPreloadedValues = (data) => {

    dispatch({
      type: 'SET_PRELOADED_VALUES',
      payload: data || [],
    });

  };

  return (
    <MultiStepFormContext.Provider
      value={{
        currentStep: state.currentStep,
        maxStep: state.maxStep,
        formDataContext: state.formDataContext,
        config: state.config,
        visibleSteps: state.visibleSteps,
        phrases: state.phrases,
        trainingId: state.trainingId,
        trainingName: state.trainingName,
        trainingNameId: state.trainingNameId,
        trainingInfos: state.trainingInfos,
        loading: state.loading,
        error: state.error,
        prevStep,
        nextStep,
        firstStep,
        setStep,
        setConfig,
        setTrainingId,
        setTrainingName,
        setTrainingInfos,
        setOrigin,
        setCookiesUTM,
        updateFormData,
        resetFormData,
        setPreloadedValues
      }}
    >
      {props.children}
    </MultiStepFormContext.Provider>
  );
};
